import React from 'react';
import {Link} from "react-router-dom";


export function ActionButton({target, icon, label}) {
    return <Link to={target}>
        <div className="action-item">
            <figure className="icon">{icon}</figure>
            <h5>{label}</h5>
        </div>
    </Link>;
}